import { useMemo } from "react";
import { useGetCompanyProposalActivityQuery } from "generated/graphql";

type UseCompanyProposalsWithEventsArgs = {
  companyId?: string | null;
  first?: number;
  page?: number;
};

export const useCompanyProposalsWithEvents = ({
  companyId,
  first = 50,
  page = 1,
}: UseCompanyProposalsWithEventsArgs) => {
  const { data, loading, error } = useGetCompanyProposalActivityQuery({
    variables: {
      companyId: companyId ?? "",
      first,
      page,
    },
    skip: !companyId,
    fetchPolicy: "cache-and-network",
  });

  const proposals = useMemo(() => {
    return data?.getCompanyProposalActivity?.data ?? [];
  }, [data]);

  const paginatorInfo = data?.getCompanyProposalActivity?.paginatorInfo;

  return { proposals, paginatorInfo, loading, error } as const;
};
